import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence, browserSessionPersistence, signInWithPopup } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

console.log('Firebase設定を初期化中...', { 
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId 
});

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// 認証の永続性を設定
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('認証の永続性が設定されました');
  })
  .catch((error) => {
    console.error('認証の永続性の設定に失敗しました:', error);
    // フォールバックとしてセッション永続性を設定
    return setPersistence(auth, browserSessionPersistence)
      .then(() => {
        console.log('フォールバック：セッション永続性が設定されました');
      })
      .catch((fallbackError) => {
        console.error('フォールバックの設定にも失敗しました:', fallbackError);
      });
  });

export const analytics = getAnalytics(app);

// Google認証プロバイダーの設定
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Googleログインのヘルパー関数
export const signInWithGoogle = async () => {
  try {
    console.log('Googleログインを開始（ポップアップ方式）...');
    const result = await signInWithPopup(auth, googleProvider);
    console.log('Googleログイン成功:', result);
    return result;
  } catch (error) {
    console.error('Googleログインエラー:', error);
    throw error;
  }
};

console.log('Firebase初期化完了');

// ユーザーの同意を得る関数
const getUserConsent = async () => {
  // LocalStorageで同意状態を確認
  const hasConsented = localStorage.getItem('deviceInfoConsent');
  if (hasConsented === 'true') return true;

  // 同意を求めるダイアログを表示
  const consent = window.confirm(
    'サービスの品質向上のため、お使いのデバイス情報を収集させていただきます。\n' +
    'これには、ブラウザの種類、言語設定、画面解像度などの基本的な情報が含まれます。\n' +
    'この情報収集に同意しますか？'
  );

  // 同意状態を保存
  if (consent) {
    localStorage.setItem('deviceInfoConsent', 'true');
  }

  return consent;
};

// デバイス情報の収集
export const collectDeviceInfo = async () => {
  const userConsent = await getUserConsent();
  if (!userConsent) {
    console.log('デバイス情報の収集が許可されませんでした');
    return null;
  }
  
  return {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    isOnline: navigator.onLine,
    collectedAt: new Date().toISOString()
  };
};

export const db = getFirestore(app);
export default app;
